import React, {useCallback, useEffect, useMemo, useState} from 'react';

import {getEventFamilies} from 'src/modules/event-families/services';
import {UsersInfoController} from 'src/modules/users-info/users-info.controller';
import {
    getAllEventFamilies,
    removeEventFamilyByNameFailure,
    saveEventFamily,
    saveEventFamilyFailure,
    saveEventFamilySuccess,
} from 'src/openapi/apis/EventFamilyControllerApi';
import {useAppDispatch, useAppSelector} from 'src/store';

import {Icons} from '@pb/kit-component-icon';
import {Status, usePushNotification} from '@pb/kit-component-push-notification';

import {EventFamiliesView} from './event-families.view';

const SUCCESS_AUTO_HIDE_TIMEOUT = 2000;
const ERROR_AUTO_HIDE_TIMEOUT = 10000;

export const EventFamiliesController = () => {
    const dispatch = useAppDispatch();
    const {onCreateNote} = usePushNotification();
    const [newFamily, setNewFamily] = useState<string>('');
    const families = useAppSelector(getEventFamilies);
    const userEmails = useMemo(() => {
        return [...new Set(families.map(family => family.createdBy))];
    }, [families]);

    useEffect(() => {
        dispatch(getAllEventFamilies());
    }, [dispatch]);

    const onSaveHandle = useCallback(async () => {
        const response =
            await dispatch(saveEventFamily({saveEventFamilyRequest: {name: newFamily}}));

        if (response.payload.success) {
            dispatch(getAllEventFamilies());
            onCreateNote({
                id: saveEventFamilySuccess.type,
                status: Status.SUCCESS,
                message: 'Saved',
                buttonProps: {iconProps: {type: Icons.CLOSE}},
                autoHideTimeout: SUCCESS_AUTO_HIDE_TIMEOUT,
            });
            setNewFamily('');
        }

        if (response.payload.error) {
            onCreateNote({
                id: saveEventFamilyFailure.type,
                status: Status.ERROR,
                message: response.payload?.data?.message ?? 'Unknown error',
                buttonProps: {iconProps: {type: Icons.CLOSE}},
                autoHideTimeout: ERROR_AUTO_HIDE_TIMEOUT,
            });
        }
    }, [dispatch, newFamily, onCreateNote]);

    const onRemoveErrorHandle = useCallback((message?: string) => {
        onCreateNote({
            id: removeEventFamilyByNameFailure.type,
            status: Status.ERROR,
            message: message ?? 'Unknown error',
            buttonProps: {iconProps: {type: Icons.CLOSE}},
            autoHideTimeout: ERROR_AUTO_HIDE_TIMEOUT,
        });
    }, [onCreateNote]);

    return (
        <>
            <UsersInfoController emails={userEmails}/>
            <EventFamiliesView
                newFamily={newFamily}
                setNewFamily={setNewFamily}
                families={families}
                onSave={onSaveHandle}
                onRemoveError={onRemoveErrorHandle}
            />
        </>
    );
};
